import { create } from "zustand";
import { setLocale as applyLocale } from "@mypos/ui";
import { idb } from "./idb";

export type Locale = "en" | "lo";

const STORAGE_KEY = "mypos.manager.locale";
const IDB_KEY = "settings.locale";

function localSeed(): Locale {
  try {
    const v = localStorage.getItem(STORAGE_KEY);
    if (v === "en" || v === "lo") return v;
  } catch { /* ignore */ }
  return "en";
}

interface LocaleState {
  locale: Locale;
  setLocale(l: Locale): void;
  hydrate(): Promise<void>;
}

export const useLocaleStore = create<LocaleState>((set, get) => ({
  locale: localSeed(),

  setLocale(l) {
    set({ locale: l });
    applyLocale(l);
    try { localStorage.setItem(STORAGE_KEY, l); } catch { /* ignore */ }
    void idb.set(IDB_KEY, l).catch(() => { /* offline / quota — localStorage seed is the fallback */ });
  },

  async hydrate() {
    applyLocale(get().locale);
    try {
      const persisted = await idb.get<Locale>(IDB_KEY);
      if ((persisted === "en" || persisted === "lo") && persisted !== get().locale) {
        set({ locale: persisted });
        applyLocale(persisted);
        try { localStorage.setItem(STORAGE_KEY, persisted); } catch { /* ignore */ }
      }
    } catch { /* idb unavailable — keep seed */ }
  },
}));
